import { Injectable, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { User } from './user';

@Injectable({
    providedIn: 'root'
})
export class UserEventService {

    /**  Propiedad miter del componenete */
    public eventPhoto = new EventEmitter();

    /** SUbcripcion */
    public subscriptionPhoto: Subscription;

    constructor() { }

    /** Evento para cambiar foto */
    updatePhoto(user: User) {
       
        this.eventPhoto.emit(user);
    }

}